export const locale = () => document.documentElement.lang;

import 'bootstrap';
import Alpine from 'alpinejs';
import AlpineI18n from 'alpinejs-i18n';
import persist from '@alpinejs/persist';
import News from './components/news';
import Orders from './components/orders';
import Registration from './components/registration';
import TextareaAutoheight from './components/textarea-autoheight';
import HomepageVideo from './components/homepage-video';
import asyncForm from './components/async-form';
import orderPopup from './components/order-popup';
import purchaseToDataLayer from './components/purchase-to-data-layer';
import customPayments from './components/custom-payments';

window.Alpine = Alpine;

Alpine.plugin(AlpineI18n);
Alpine.plugin(persist);

Alpine.data('news', News);
Alpine.data('orders', Orders);
Alpine.data('registration', Registration);
Alpine.data('textareaAutoheight', TextareaAutoheight);
Alpine.data('homepageVideo', HomepageVideo);
Alpine.data('asyncForm', asyncForm);
Alpine.data('orderPopup', orderPopup);
Alpine.data('purchaseToDataLayer', purchaseToDataLayer);
Alpine.data('customPayments', customPayments);

Alpine.magic('money', () => (amount, currency = 'CZK') => {
  let currencySing = currency.toUpperCase() === 'CZK' ? 'Kč' : 'EUR';
  return `${parseInt(amount).toLocaleString(locale())} ${currencySing}`;
});

Alpine.magic('date', () => (date, options = {}) => {
  let fomatedDate = new Date(date);
  return fomatedDate.toLocaleDateString(locale(), options);
});

Alpine.magic('time', () => (date, options = {}) => {
  let fomatedDate = new Date(date);
  return fomatedDate.toLocaleTimeString(locale(), options);
});

Alpine.start();
